// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../node_modules/monaco-editor/monaco.d.ts" />
export const InfoveaveTheme: monaco.editor.IStandaloneThemeData = {
  base: "vs",
  inherit: false,
  rules: [
    { token: "user-name", foreground: "0D47A1", fontStyle: "bold" },
    { token: "mdx-cube", foreground: "0D47A1", fontStyle: "bold" },
    { token: "mdx-filter", foreground: "006064", fontStyle: "bold" },
    { token: "mdx-measure", foreground: "0097A7", fontStyle: "bold" },
    { token: "mdx-dimension", foreground: "512DA8", fontStyle: "bold" },
    { token: "excel-measure", foreground: "0D47A1" },
    { token: "excel-dimension", foreground: "006064" },
    { token: "excel-logical", foreground: "0097A7" },
    { token: "excel-statistical", foreground: "0288D1" },
    { token: "excel-math-trig", foreground: "512DA8" },
    { token: "excel-date-time", foreground: "303F9F" },
    { token: "excel-engineering", foreground: "1976D2" },
    { token: "excel-financial", foreground: "7B1FA2" },
    { token: "excel-information", foreground: "689F38" },
    { token: "excel-lookup-reference", foreground: "00796B" },
    { token: "excel-text", foreground: "388E3C" },
    { token: "excel-cube", foreground: "388E3C" },
    { token: "excel-database", foreground: "388E3C" },
    { token: "keyword", foreground: "0D47A1" },
    { token: "assignment", foreground: "0097A7" },
    { token: "string", foreground: "0288D1" },
    { token: "string.quote", foreground: "0288D1" },
    { token: "number", foreground: "512DA8" },
    { token: "number.float", foreground: "512DA8" },
    { token: "number.hex", foreground: "512DA8" },
    { token: "parameter", foreground: "303F9F" },
    { token: "column-name", foreground: "0D47A1", fontStyle: "bold" },
    { token: "keyword", foreground: "1976D2" },
    { token: "action", foreground: "0D47A1" },
    { token: "identifier", foreground: "512DA8" },
    { token: "column-name", foreground: "689F38" },
    { token: "comment", foreground: "008800" },
    { token: "askAnything-filter", foreground: "f1c40f", fontStyle: "bold" },
    { token: "askAnything-measure", foreground: "2ecc71", fontStyle: "bold" },
    { token: "askAnything-dimension", foreground: "3498db", fontStyle: "bold" },
  ],
  colors: {},
};

export const SciPyR: monaco.editor.IStandaloneThemeData = {
  base: "vs",
  inherit: true,
  rules: [],
  colors: {
    "editor.foreground": "#000000",
    "editor.background": "#f5f5f5",
    "editorCursor.foreground": "#8B0000",
    "editor.lineHighlightBackground": "#0000FF20",
    "editorLineNumber.foreground": "#626262",
    "editor.selectionBackground": "#88000030",
    "editor.inactiveSelectionBackground": "#88000015",
  },
};
